export default "ui-series{display:none}\n";